import { TableSortLabel, Typography } from '@mui/material';

import type { TSortDirection, TSortKey } from '@/components/filter/types';

import type { TSxStyles } from '@/types/common';

type THeadLabelProps = {
  label: string;
  sortKey: TSortKey | undefined;
  onSort: (sortKey: TSortKey) => void;
  sorted: TSortDirection | undefined | false;
  leftIcon: boolean;
  alwaysShowIcon?: boolean;
};

const leftIconStyles: TSxStyles = {
  '& .MuiTableSortLabel-icon': {
    position: 'absolute',
    right: '100%',
  },
};

const alwaysVisibleIconStyles: TSxStyles = {
  '& .MuiTableSortLabel-icon': {
    opacity: 1,
  },
};

/**
 * What: the text of one column heading, with an optional sort control.
 * Why: the heading look (12px / 600 / secondary colour) lives in the theme's table head cell; the
 * label inherits it (`color` and `fontWeight` "inherit") so every table header matches.
 * Constraints: `noWrap` keeps the label on one line.
 */
export const HeadLabel = ({
  label,
  sortKey,
  onSort,
  sorted,
  leftIcon,
  alwaysShowIcon,
}: THeadLabelProps) => {
  if (!sortKey) {
    return (
      <Typography variant="caption" color="inherit" fontWeight="inherit" noWrap>
        {label}
      </Typography>
    );
  }

  return (
    <TableSortLabel
      active={!!sorted}
      direction={sorted || undefined}
      onClick={() => onSort(sortKey)}
      sx={{
        ...(leftIcon ? leftIconStyles : {}),
        ...(alwaysShowIcon ? alwaysVisibleIconStyles : {}),
      }}
    >
      <Typography variant="caption" color="inherit" fontWeight="inherit" noWrap>
        {label}
      </Typography>
    </TableSortLabel>
  );
};
